module.exports = __webpack_public_path__ + "large3.jpg?6c95b3b8dae7bd319861899f348d4259";